import { useTranslation } from 'react-i18next';
import { Modal } from 'Components';

const LogoutModal = ({ onLogout, onCancel }: { onLogout: () => void, onCancel: () => void }) => {
    const { t } = useTranslation();

    return <Modal
        visible
        title={t('appHeader.logout.title')}
        onOk={onLogout}
        okText={t('appHeader.logout.title')}
        cancelText={t('cancel')}
        onCancel={onCancel}
    >
        {t('appHeader.logout.description')}
    </Modal>
}

export default LogoutModal;